import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const InternationalSchools = () => {
  const { t } = useTranslation();

  return (
    <ImageLoader>
      <Container>
        <Row className="section border">
          <Col md={12}>
            <Row className="bottom-padding">
              <AnimateOnScroll animationType="slideUp">
                <img src="/images/4.jpg" alt="One Oasis" className="fullimg" />
              </AnimateOnScroll>
            </Row>
          </Col>

          <Col md={3}>
            <Row className="bottom-padding">
              <AnimateOnScroll animationType="slideRight">
                <img
                  src="/images/WhatsApp Image 2025-05-22 at 3.06.35 PM.jpeg"
                  alt="One Oasis"
                  className="fullimg"
                />
              </AnimateOnScroll>
            </Row>
          </Col>
          <Col
            md={9}
            className="d-flex flex-column justify-content-center bottom-padding"
          >
            <Row className="bottom-padding">
              <AnimateOnScroll animationType="slideLeft">
                <h2>{t("schools_main_title")}</h2>
                <p>{t("schools_main_p")}</p>
              </AnimateOnScroll>
            </Row>
          </Col>

          <Col md={6}>
            <AnimateOnScroll animationType="slideUp" delay={0.1}>
              <img
                src="/images/WhatsApp Image 2025-05-22 at 3.05.58 PM.jpeg"
                alt="One Oasis"
                className="fullimg"
              />
            </AnimateOnScroll>
          </Col>

          <Col md={6}>
            <AnimateOnScroll animationType="slideUp" delay={0.2}>
              <img
                src="/images/WhatsApp Image 2025-05-22 at 3.05.39 PM.jpeg"
                alt="One Oasis"
                className="fullimg"
              />
            </AnimateOnScroll>
          </Col>
        </Row>
      </Container>
    </ImageLoader>
  );
};

export default InternationalSchools;
